import { useEffect, useRef, useState } from 'react';

const categories = [
  { icon: 'ri-heart-pulse-line', title: 'Cuidado personal', desc: 'Productos para tu higiene y bienestar diario.' },
  { icon: 'ri-capsule-line', title: 'Vitaminas y suplementos', desc: 'Apoyo nutricional para tu estilo de vida.' },
  { icon: 'ri-parent-line', title: 'Bebé y maternidad', desc: 'Artículos para el cuidado de tu pequeño.' },
  { icon: 'ri-first-aid-kit-line', title: 'Dispositivos médicos', desc: 'Equipos de monitoreo y primeros auxilios.' },
  { icon: 'ri-shining-line', title: 'Dermocosmética', desc: 'Cuidado de la piel con respaldo profesional.' },
  { icon: 'ri-leaf-line', title: 'Bienestar y nutrición', desc: 'Opciones naturales para tu salud integral.' },
];

export default function QueLlevamos() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="que-llevamos"
      ref={ref}
      className="bg-white py-[72px] md:py-24"
    >
      <div className="mx-auto max-w-[1200px] px-6 md:px-12">
        <h2 className="mb-14 text-center font-serif text-[28px] font-bold text-md-ink md:mb-16 md:text-[42px]">
          Productos para el cuidado de tu hogar
        </h2>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat, i) => (
            <div
              key={cat.title}
              className={`group rounded-2xl bg-md-bg p-7 text-center transition-all duration-300 hover:-translate-y-1 hover:border-md-teal hover:shadow-[0_4px_16px_rgba(15,31,53,0.08)] md:p-8 ${
                visible ? 'animate-fade-in-up' : 'opacity-0'
              }`}
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-[inset_0_2px_8px_rgba(15,31,53,0.06)]">
                <span className="flex h-8 w-8 items-center justify-center text-[28px] text-md-blue">
                  <i className={cat.icon} />
                </span>
              </div>
              <h3 className="mb-2 font-sans text-[16px] font-semibold text-md-ink md:text-[18px]">
                {cat.title}
              </h3>
              <p className="text-[13px] leading-[1.5] text-md-slate md:text-[14px]">
                {cat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}